/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateAgentPolicyGrantForm,
  CreateAgentPolicyGrantForm$Outbound,
  CreateAgentPolicyGrantForm$outboundSchema,
} from "../components/createagentpolicygrantform.js";

export type CreateAgentPolicyGrantSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type CreateAgentPolicyGrantRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  createAgentPolicyGrantForm: CreateAgentPolicyGrantForm;
};

/** @internal */
export type CreateAgentPolicyGrantSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateAgentPolicyGrantSecurity$outboundSchema: z.ZodMiniType<
  CreateAgentPolicyGrantSecurity$Outbound,
  CreateAgentPolicyGrantSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createAgentPolicyGrantSecurityToJSON(
  createAgentPolicyGrantSecurity: CreateAgentPolicyGrantSecurity,
): string {
  return JSON.stringify(
    CreateAgentPolicyGrantSecurity$outboundSchema.parse(
      createAgentPolicyGrantSecurity,
    ),
  );
}

/** @internal */
export type CreateAgentPolicyGrantRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  CreateAgentPolicyGrantForm: CreateAgentPolicyGrantForm$Outbound;
};

/** @internal */
export const CreateAgentPolicyGrantRequest$outboundSchema: z.ZodMiniType<
  CreateAgentPolicyGrantRequest$Outbound,
  CreateAgentPolicyGrantRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    createAgentPolicyGrantForm: CreateAgentPolicyGrantForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      createAgentPolicyGrantForm: "CreateAgentPolicyGrantForm",
    });
  }),
);

export function createAgentPolicyGrantRequestToJSON(
  createAgentPolicyGrantRequest: CreateAgentPolicyGrantRequest,
): string {
  return JSON.stringify(
    CreateAgentPolicyGrantRequest$outboundSchema.parse(
      createAgentPolicyGrantRequest,
    ),
  );
}
